import axios from 'axios';
import { z } from 'zod/v4';

import localAxios from '../localAxios';
import { baseAIURL } from './urls';

interface GetUploadUrlResponse {
  uploadUrl: string;
  fileKey: string;
}

const uploadUrlResponseSchema = z.object({
  uploadUrl: z.string(),
  fileKey: z.string(),
});
export type UploadUrlResponse = z.infer<typeof uploadUrlResponseSchema>;

export async function getFileUploadUrl(
  file: File
): Promise<GetUploadUrlResponse> {
  const url = baseAIURL();
  url.pathname += 'files/upload-url';

  if (__DEV__) {
    console.debug('[DEBUG] Upload URL:', url.href);
  }
  try {
    const response = await localAxios.post(url.href, {
      fileName: file.name,
      contentType: file.type,
      contentLength: file.size,
    });

    const { success, data, error } = uploadUrlResponseSchema.safeParse(
      response.data
    );

    if (!success) {
      throw new Error(error.message || 'Failed to get upload URL');
    }
    return data;
  } catch (error) {
    if (__DEV__) {
      console.error('[ERROR] Failed to get upload URL:', error);
    }
    throw error;
  }
}

interface UploadFileParams {
  file: File;
  onUploadProgress?: (progressEvent: ProgressEvent) => void;
}

export async function uploadFile({
  file,
  onUploadProgress,
}: UploadFileParams): Promise<string> {
  const { uploadUrl, fileKey } = await getFileUploadUrl(file);

  await axios.put(uploadUrl, file, {
    withCredentials: false,
    headers: {
      'Content-Type': file.type,
    },
    onUploadProgress,
  });

  return fileKey;
}
